// extracted by mini-css-extract-plugin
export default {"home":"Donation_home__np7BE","logo":"Donation_logo__25kDg"};